<template>
  <section>
    <notifications></notifications>
    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-4 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0 && canUserDelete"
              type="outline-neutral"
              class="min-button btn-line-danger mr-2"
              @click="deleteManyProducts(selectedRows)"
            >
              <i class="flaticon-delete icon-no-margin"></i>
              <strong class="d-lg-block d-none">Delete</strong>
            </base-button>

            <base-button
              v-if="canUserCreate"
              type="primary"
              @click="goToNewProduct()"
              class="min-button"
            >
              <i class="flaticon-plus"></i>New
              <strong class="d-lg-block d-none ml-1"> Experience</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 align-self-center mb-md-0 mb-3"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>

          <div
            class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 mb-md-0 mb-3  align-self-center"
          >
            <div
              class="input-group flackpick-group with-append-select mb-0 py-1 pl-5i select-search"
            >
              <div class="input-group-prepend pl-1">
                <i class="pl-1"></i>
              </div>
              <el-select
                class="select-drop"
                id="search"
                name="search"
                filterable
                remote
                reserve-keyword
                :filter-method="filterDestinationOptions"
                placeholder="Search by Suppliers"
                @input="selectDestination"
                v-model="destinatioId"
                no-data-text="Search by Suppliers"
                automatic-dropdown
                clearable
                ref="search"
              >
                <el-option
                  v-for="(destination, index) in destinations"
                  :value="destination._id"
                  :label="
                    `${destination.name} - ${getSupplierName(
                      destination.supplier
                    )}`
                  "
                  :key="index"
                >
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                      <span style>{{ destination.name }}</span>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-6 text-right">
                      <span class="hide-data coin-right">
                        {{ getSupplierName(destination.supplier) }}
                      </span>
                    </div>
                  </div>
                </el-option>
              </el-select>
            </div>
          </div>

          <div
            class="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-12 alinmov2 mb-sm-0 mb-3 align-self-center"
          >
            <div>
              <div class="box-buttons">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-rec"></i>
                    <strong>Status</strong>
                  </base-button>

                  <div
                    class="dropdown-item"
                    :class="productStatus === true ? 'active' : ''"
                    @click="typeSearch(true)"
                  >
                    <i class="flaticon-rec text-success mr-2"></i>
                    Active
                  </div>
                  <div
                    class="dropdown-item"
                    :class="productStatus === false ? 'active' : ''"
                    @click="typeSearch(false)"
                  >
                    <i class="flaticon-rec text-danger mr-2"></i>
                    Inactive
                  </div>
                </base-dropdown>

                <base-button
                  type="outline-neutral"
                  class="min-button"
                  v-if="canUserCreateTag"
                  @click="modalTags = true"
                >
                  <i class="flaticon-save-instagram mr-2"></i> Tags
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          ></div>

          <div
            class="col-xl-7 col-lg-12 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-1 text-right"
          >
            <div class="col-xl-5 col-lg-5 col-md-12 ml-auto d-inline-block">
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class="mb-0"
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    @change="applySortBy"
                    :aria-describedby="ariaDescribedby"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block d-inline-flex mr-3 mb-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="viewProducts"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewProducts"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card-h"
                    ><i class="flaticon-grid" title="View Card horizontal"></i
                  ></b-form-radio>

                  <b-form-radio value="card-v"
                    ><i class="flaticon-menu" title="View Card vertical"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2 mb-2">
              <el-tooltip
                content="Manage columns"
                placement="bottom"
                class="d-inline-flex"
              >
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="modalManageColumn = true"
                >
                  <i class="flaticon-bold-settings mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>

            <div v-if="canUserExport" class="d-inline-block mr-2 mb-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-downloading-files mr-0 mt-2"></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="download(selectedRows)"
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="download([])">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>
            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <pagination-block
          :pageCount="products.pages"
          v-model="currentPage"
          :total="products.count"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          position="bottom"
        ></pagination-block>

        <div v-if="viewProducts === 'table'">
          <b-table
            hover
            :items="experiences"
            :fields="fields"
            sort-by.sync="category"
            sort-asc.sync="true"
            selectable
            @row-selected="onRowSelected"
            select-mode="multi"
            ref="selectableTable"
            sort-icon-left
            responsive
            show-empty
            empty-filtered-text="There are no records matching your request"
            empty-text="There are no records to show"
            :table-class="getTableClass(experiences)"
          >
            <template #head()="{ label, field: { key } }">
              <span v-if="key === 'selected'">
                <span
                  @click="clearSelected"
                  v-if="selectedRows.length === experiences.length"
                  class="check-table selected"
                ></span>

                <span @click="selectAllRows" v-else class="check-table"></span>
              </span>
              <span v-else>{{ label }}</span>
            </template>

            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true" class="check-table selected"></span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true" class="check-table"></span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>

            <template #thead-top="data">
              <draggable
                tag="b-tr"
                v-model="fields"
                @change="changDraggable"
                draggable=".dragg"
                sortable="true"
                :sort="true"
              >
                <b-th
                  v-for="(field, index) in fields"
                  :key="index"
                  class="draggable text-center"
                  :class="[
                    {
                      'no-drag': !field.settings.drag,
                      dragg: field.settings.drag,
                      'b-table-sort-icon-left': field.sortable
                    }
                  ]"
                  style="padding: 0px 10px 10px 10px !important"
                  :width="field.width"
                >
                  <span class="drag-drop" v-if="field.settings.drag"> </span>
                </b-th>
              </draggable>
            </template>

            <template #cell(productCode)="data">
              <router-link
                class="capitalize hide-data"
                :to="`/experiences/rhomtrip/${data.item.product._id}?mode=view`"
              >
                {{ data.item.product.code }}
              </router-link>
            </template>

            <template #cell(title)="data">
              <div class="d-flex align-items-center min-img-product">
                <LazyImage
                  :src="data.item.product.images[0]"
                  imgClasses="img-experience-min"
                  beforeClasses="d-inline-flex"
                  @click="openBox(data.index)"
                />
                <router-link
                  :to="
                    `/experiences/rhomtrip/${data.item.product._id}?mode=view`
                  "
                  class="title multiline-3 d-inline-flex"
                >
                  {{ data.item.product.name }}
                </router-link>
              </div>
            </template>

            <template #cell(destination)="data">
              <span class="role-table">{{
                data.item.product.destination.country.name
              }}</span>
              <span class="hide-data">{{
                data.item.product.destination.city
              }}</span>
              <span class="role-table">{{
                data.item.product.supplier.name
              }}</span>
            </template>

            <template #cell(category)="data">
              <span class="hide-data">{{
                getExperienceType(data.item.product.type)
              }}</span>
            </template>

            <template #cell(vehicle)="data">
              <div class="box-img-card">
                <div class="content ">
                  <span class="capitalize hide-data title fw-100">
                    {{ formatCategory(data.item.product.service.category) }}
                  </span>

                  <span class="hide-data subtitle-1">{{
                    data.item.product.service.vehicle.name
                  }}</span>
                  <span class="hide-data subtitle-2">{{
                    formatVehicleType(data.item.product.service.vehicle.type)
                  }}</span>
                </div>
              </div>
            </template>

            <template #cell(seats)="data">
              <span class="hide-data">{{
                data.item.product.passengers.maximum
              }}</span>
            </template>

            <template #cell(transferType)="data">
              <span
                v-html="getTypeTransfer(data.item.product.transfer.type)"
                class="hide-data"
              >
              </span>
            </template>

            <template #cell(quote)="data">
              <span>
                {{ getQuoteFormat(data.item.product.quote) }}
              </span>
            </template>
            <template #cell(areaCode)="data">
              <span class="hide-data">{{ data.item.product.area.name }}</span>
            </template>

            <template #cell(availability)="data">
              <span class="hide-data">{{
                toTitleCase(data.item.product.availability.type)
              }}</span>
            </template>

            <template #cell(pricingMethod)="data">
              <span class="hide-data">{{
                toTitleCase(data.item.product.pricing_method)
              }}</span>
            </template>

            <template #cell(cutoff)="data">
              <span class="role-table">{{
                toTitleCase(data.item.product.cutoff.type)
              }}</span>
              <span class="hide-data">{{
                data.item.product.cutoff.value +
                  " " +
                  toTitleCase(data.item.product.cutoff.unit)
              }}</span>
            </template>

            <template #cell(basePrice)="data">
              <span
                >{{ data.item.product.currency.symbol }}
                {{ getFormattedProductPrice(data.item.product.pricing.amount) }}
                {{ data.item.product.currency.code }}</span
              >
            </template>

            <template #cell(status)="data">
              <div
                class="badge-status"
                :class="{
                  'badge-success': data.item.product.status,
                  'badge-danger': !data.item.product.status
                }"
              >
                <span v-if="data.item.product.status">Active</span>
                <span v-else>Inactive</span>
              </div>
            </template>

            <template #cell(actions)="data">
              <div class="action-column">
                <div class="button-action mr-2">
                  <el-tooltip
                    content="History"
                    placement="bottom"
                    class="d-inline-flex"
                  >
                    <span
                      class="icon-action text-blue"
                      @click.stop="
                        openExperienceHistory(
                          data.item.product._id,
                          data.item.product.code
                        )
                      "
                    >
                      <i class="flaticon-wall-clock-1"> </i>
                    </span>
                  </el-tooltip>
                </div>
                <div class="drop-action d-inline-block">
                  <base-dropdown
                    menu-on-right
                    class="nav-item"
                    tag="li"
                    title-tag="a"
                    title-classes="dropnocaret"
                    title="Actions"
                    :direction="getDirection(products.docs, data.index)"
                  >
                    <span slot="title">
                      <i class="flaticon-bold-kebab"></i>
                    </span>

                    <DropdownActionItem
                      :baseRoute="
                        `/experiences/rhomtrip/${data.item.product._id}`
                      "
                      :canUpdate="canUserUpdate"
                      :canRead="canUserRead"
                      :editLabel="'Edit Experience'"
                      :viewLabel="'View Experience'"
                    />

                    <div
                      v-if="canUserUpdate"
                      class="dropdown-item"
                      @click="
                        changeStatus(
                          data.item.product._id,
                          !data.item.product.status
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-right-4 text-info"></i> Change Status
                      </span>
                    </div>

                    <div
                      class="dropdown-item"
                      @click="
                        $router.push(
                          `/experiences/rhomtrip/web-preview/${data.item.product._id}`
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-visualization text-new"></i> Web
                        Preview
                      </span>
                    </div>

                    <div
                      v-if="canUserCreate"
                      class="dropdown-item"
                      @click="duplicateProduct(data.item.product._id)"
                    >
                      <span class="icon-action">
                        <i class="flaticon-copy"></i>Duplicate
                      </span>
                    </div>

                    <div
                      v-if="canUserDelete"
                      class="dropdown-item"
                      @click="deleteProduct(data.item.product._id)"
                    >
                      <span class="icon-action">
                        <i class="flaticon-delete text-danger"></i>Delete
                      </span>
                    </div>
                  </base-dropdown>
                </div>
              </div>
            </template>
          </b-table>
        </div>

        <div v-else-if="viewProducts === 'card-h'">
          <div class="col-lg-12">
            <div class="row justify-content-center">
              <div
                class="col-xl-9 col-lg-11 col-md-11 col-sm-12 col-12 mb-3"
                v-for="(product, index) in products.docs"
                :key="index"
              >
                <cardHorizontal
                  :product="product"
                  :index="index"
                  :excerpt="true"
                  size="lg"
                  source="RHOMTRIP"
                ></cardHorizontal>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="viewProducts === 'card-v'">
          <div class="col-lg-12 p-0">
            <div class="row justify-content-center">
              <div
                v-for="(product, index) in products.docs"
                :key="index"
                class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 mb-3 box-flex"
              >
                <cardVertical
                  :product="product"
                  :index="index"
                  :excerpt="true"
                  size="lg"
                  source="RHOMTRIP"
                ></cardVertical>
              </div>
            </div>
          </div>
        </div>

        <pagination-block
          :pageCount="products.pages"
          v-model="currentPage"
          :total="products.count"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          position="bottom"
        ></pagination-block>
      </div>

      <ManageTableColumns
        :value="modalManageColumn"
        :fields="fields"
        :tableGridConfig="tableGridConfig"
        :mandatories="['productCode', 'title']"
        @saveColumns="saveColumnsInUserAccount"
        @closeTableGridModal="closeTableGridModal"
      />
    </div>

    <TagsManager :show="modalTags" @closeTagsModal="closeTagsModal" />
    <LightBox
      v-if="showLightbox"
      :media="imagesExperiences"
      :showLightBox="showLightbox"
    />
    <ExperienceHistory
      :show="showExperienceHistory"
      :experienceId="tempExperienceId"
      :experienceCode="tempExperienceCode"
      @close="closeExperienceHistoryModal"
    />
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  SettingsAPI,
  ProductsAPI,
  DocumentsAPI
} from "../../../../../core/api";
import Swal from "sweetalert2";
import moment from "moment";
import TagsManager from "../components/TagsManager.vue";
import { BCarousel } from "bootstrap-vue";
import cardVertical from "../../../components/cards/CardVertical.vue";
import cardHorizontal from "../../../components/cards/CardHorizontal.vue";
import lodash from "lodash";
import LightBox from "vue-image-lightbox";
import "vue-image-lightbox/dist/vue-image-lightbox.min.css";
import ExperienceHistory from "../components/ExperienceHistory.vue";
import ManageTableColumns from "@/components/ManageTableColumns.vue";
import draggable from "vuedraggable";
import {
  goBack,
  isUserAuthorized,
  setSigOut
} from "../../../../../helpers/commons.helpers";
import { EXPERIENCES_TABLE_DEFAULTS } from "../../../../../core/constants";

export default {
  name: "Experiences",
  components: {
    TagsManager: TagsManager,
    "b-carousel": BCarousel,
    cardVertical,
    cardHorizontal,
    LightBox,
    ExperienceHistory: ExperienceHistory,
    ManageTableColumns: ManageTableColumns,
    draggable
  },

  data() {
    return {
      selectedRows: [],
      currentPage: 1,
      modalManageColumn: false,
      fields: [],
      tableGridConfig: [],
      cardview: true,
      limit: 0,
      simpleSearch: "",
      query: "",
      sortBy: "",
      sortDesc: "asc",
      sortOptions: [
        { value: "name", text: "Title" },
        { value: "seats", text: "Seats" },
        { value: "suitcases", text: "Suitcases" },
        { value: "price", text: "Price" },
        { value: "created_at", text: "Created At" }
      ],
      viewProducts: "table",
      productStatus: null,
      modalTags: false,
      timeoutId: null,
      guides: [],
      loader: false,
      visibleSideBar: false,
      imagesExperiences: [],
      showLightbox: false,
      showExperienceHistory: false,
      tempExperienceId: null,
      tempExperienceCode: null,
      destinatioId: null,
      destinations: []
    };
  },
  watch: {
    branchesOptions: {
      handler(newVal) {
        this.destinations = newVal;
      },
      immediate: true
    }
  },
  async created() {
    this.tableGridConfig = EXPERIENCES_TABLE_DEFAULTS;
    this.fields = this.populateFields(this.settings);
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "RhomTrip Experiences",
        active: true
      }
    ];
    this.setItemsBread(bread);
    await this.getLimit();
    this.limit = this.paginationLimit;
    this.currentPage = this.productSearchCriteria.currentPage;
    this.query = this.productSearchCriteria.query;
    this.initializeFilterData(this.query);
    this.get(true, this.limit, this.currentPage, this.query);
  },

  methods: {
    toTitleCase(str) {
      if (typeof str == "string")
        return str.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase());
      else return str;
    },
    async changDraggable(column) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.experiences.tableLayouts": this.fields }
      );
      if (status) {
        this.setSettings(settings);
      }
    },
    closeTableGridModal(status) {
      this.modalManageColumn = status;
    },
    async saveColumnsInUserAccount(fields = []) {
      this.modalManageColumn = false;
      this.fields = fields;
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.experiences.tableLayouts": this.fields }
      );
      if (status) {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "Columns have been changed",
          icon: "flaticon-check-3"
        });
        this.setSettings(settings);
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "Columns haven't been changed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async updateSettingLayoutsByUserId(userId, payload) {
      try {
        let { data } = await SettingsAPI.updateSettingLayoutsByUserId(
          userId,
          payload,
          this.sesion.token
        );
        if (data.status) {
          return { status: true, settings: data.data.settings };
        } else {
          return { status: false, settings: null };
        }
      } catch (error) {
        return { status: false, settings: null };
      }
    },
    populateFields(settings) {
      try {
        if (settings) {
          if (settings.experiences.tableLayouts.length > 0) {
            return settings.experiences.tableLayouts;
          }
        }
        return EXPERIENCES_TABLE_DEFAULTS.filter(option => {
          return option.settings.default;
        });
      } catch (error) {
        return EXPERIENCES_TABLE_DEFAULTS.filter(option => {
          return option.settings.default;
        });
      }
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(
          key,
          value ? (typeof value === "string" ? value.trim() : value) : value
        );
      } else {
        searchParams.append(
          key,
          value ? (typeof value === "string" ? value.trim() : value) : value
        );
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        this.get(true, this.limit, this.currentPage, this.query);
      }
    },
    previousPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    nextPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    changePage(page) {
      this.get(true, this.limit, page, this.query);
    },
    async deleteProduct(productId) {
      let { value } = await Swal.fire({
        title: "Delete Experience",
        html:
          "Are you sure do you want to <strong>delete</strong> <br>this Experience?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteProductById(productId);
      }
    },
    async deleteProductById(productId) {
      try {
        this.setLoad(true);
        let { data } = await ProductsAPI.deleteProductById(
          productId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.get(true, this.limit, 1, this.query);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Experience has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    async deleteManyProducts(products = []) {
      let { value } = await Swal.fire({
        title: "Delete Experiences",
        html:
          "Are you sure do you want to <strong>delete</strong> <br> the selected Experiences?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyProductsById(products.map(element => element._id));
      }
    },
    async deleteManyProductsById(products = []) {
      try {
        this.setLoad(true);
        let { data } = await ProductsAPI.deleteManyProductsById(
          products,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.get(true, this.limit, 1, this.query);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Experience has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    async download(products = []) {
      try {
        this.setLoad(true);
        let { data } = await ProductsAPI.exportProducts(
          this.query,
          { products: products },
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `products-${moment().format("DD-MM-YYYY")}.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The data was not download. Please try again");
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    async changeStatus(productId, status) {
      let { value } = await Swal.fire({
        title: "Change Status",
        html: `Are you sure do you want <strong>change status</strong> <br>the selected product?`,
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.changeStatusProductById(productId, status);
      }
    },
    async changeStatusProductById(productId, status) {
      try {
        let { data } = await ProductsAPI.updateAnyAttributeById(
          productId,
          { status: status },
          this.sesion.token
        );
        if (data.status) {
          this.showNotify(
            "success",
            "Success!",
            "This product has been actived",
            "flaticon-check-mark"
          );
          this.get(true, this.limit, this.currentPage, this.query);
        } else {
          this.showNotify(
            "success",
            "Success!",
            "This product has been deactivate",
            "flaticon-check-mark"
          );
        }
      } catch (error) {
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    showNotify(type, title, message, icon) {
      this.$notify({
        type: type,
        title: title,
        message: message,
        icon: icon
      });
    },
    applySimpleSearch(value) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        if (value) {
          this.query = this.addElementInQuery(this.query, "search", value);
          this.get(true, this.limit, 1, this.query);
        } else {
          this.query = this.deleteItemInQuery(this.query, ["search"]);
          this.get(true, this.limit, 1, this.query);
        }
      }, 500);
    },
    typeSearch(status) {
      this.productStatus = status;
      if (status !== "all") {
        this.query = this.addElementInQuery(this.query, "status", status);
        this.get(true, this.limit, 1, this.query);
      } else {
        this.query = this.deleteItemInQuery(this.query, ["status"]);
        this.get(true, this.limit, 1, this.query);
      }
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async get(loader, limit, page, query) {
      await this.getProducts({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
      this.setProductSearchCriteria({
        currentPage: page,
        limit: limit,
        query: query,
        status: true
      });
    },
    async applySortBy(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", value);
      this.query = this.addElementInQuery(
        this.query,
        "sortType",
        this.sortDesc
      );
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortType", value);
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    changeViewProducts(value) {
      this.viewProducts = value;
    },
    initializeFilterData(query) {
      let searchCriteria = new URLSearchParams(query);
      this.simpleSearch = searchCriteria.has("search")
        ? searchCriteria.get("search")
        : "";
      this.destinatioId = searchCriteria.has("destination")
        ? searchCriteria.get("destination")
        : "";

      this.productStatus = searchCriteria.has("status")
        ? searchCriteria.get("status")
        : "";
    },
    isInProductModule(modules = []) {
      if (!modules.includes("experiences")) {
        this.setProductSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },

    closeTagsModal(status) {
      this.modalTags = false;
    },
    getDirection: function(products = [], index) {
      if (products.length >= 5) {
        let position = products.length - index;
        if (position === 5) {
          return "down";
        } else {
          return position > 5 ? "down" : "up";
        }
      } else {
        return "down";
      }
    },
    getTableClass(items = []) {
      return items.length < 7 ? "b-table-separator" : "";
    },
    async duplicateProduct(productId) {
      let { value } = await Swal.fire({
        title: "Duplicate Experience",
        html:
          "Are you sure you want to <strong>duplicate</strong> this Experience?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.duplicateProductIdById(productId, true);
      }
    },
    async duplicateProductIdById(productId, populate) {
      try {
        let { data } = await ProductsAPI.getProductById(
          productId,
          this.sesion.token
        );
        if (data.status) {
          let product = this.removeAttributesThatWillNotBeDuplicated(
            lodash.cloneDeep(data.data)
          );
          this.setDuplicatedProduct(product);
          this.$router.push("/experiences/rhomtrip/new");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    removeAttributesThatWillNotBeDuplicated(product) {
      delete product._id;
      delete product.created_at;
      delete product.updatedAt;
      delete product.title;
      delete product.__v;
      return product;
    },
    goToNewProduct() {
      this.setDuplicatedProduct(null);
      this.$router.push("/experiences/rhomtrip/new");
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("INTERNAL", "EXPERIENCES");
      this.loader = false;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await DocumentsAPI.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    getExperienceType(type) {
      if (type === "EVENTE") {
        return "Event";
      } else if (type === "PRIVATE_TRANSFER") {
        return "Private Transfer";
      } else if (type === "ATTRACTION") {
        return "Attraction";
      } else if (type === "TOUR") {
        return "Tour";
      }
    },
    formatCategory(type) {
      if (type === "STANDARD") {
        return "Standard Class";
      } else if (type === "BUSINESS") {
        return "Business Class";
      } else {
        return "Luxury Class";
      }
    },
    formatVehicleType(type) {
      if (type === "sedan") {
        return "Sedan";
      } else if (type === "boat") {
        return "Boat";
      } else if (type === "coach") {
        return "Coach";
      } else if (type === "limousine") {
        return "Limousine";
      } else if (type === "minibus") {
        return "Minibus";
      } else if (type === "midicoach") {
        return "Midicoach";
      } else if (type === "minivan") {
        return "Minivan";
      } else if (type === "mpv") {
        return "Mpv";
      } else if (type === "pickup") {
        return "Pickup";
      } else if (type === "premium_sedans") {
        return "Premium Sedans";
      } else if (type === "suvs") {
        return "SUVs";
      }
    },
    getTypeTransfer(type) {
      if (type === "AIRPORT") {
        return "Airport Transfer";
      } else if (type === "ARRIVAL") {
        return "Airport Transfer<br>(Arrival)";
      } else if (type === "DEPARTURE") {
        return "Airport Transfer<br>(Departure)";
      } else if (type === "STATION") {
        return "Station Transfer";
      } else if (type === "PORT") {
        return "Port Transfer";
      } else if (type === "HOURLY") {
        return "Hourly";
      } else if (type === "JOURNEY") {
        return "Journey";
      }
    },
    openBox(index) {
      this.imagesExperiences = this.products.docs
        .map(item => item.images)
        [index].map(url => ({
          thumb: url,
          src: url
        }));

      this.showLightbox = false;

      this.$nextTick(() => {
        this.showLightbox = true;
      });
    },
    openExperienceHistory(experienceId, experienceCode) {
      this.tempExperienceId = experienceId;
      this.tempExperienceCode = experienceCode;
      this.showExperienceHistory = true;
    },
    closeExperienceHistoryModal() {
      this.showExperienceHistory = false;
      this.tempExperienceId = null;
      this.tempExperienceCode = "";
    },
    getQuoteFormat(value) {
      if (value === "AREA") {
        return "Area";
      } else {
        return "From and To";
      }
    },
    getSupplierName(supplier) {
      return supplier ? supplier.businessDetails.name : "";
    },
    filterDestinationOptions(value) {
      let search = value.trim().toLowerCase();
      if (search.length > 2) {
        this.destinations = this.branchesOptions.filter(branch => {
          let supplierName = this.getSupplierName(branch.supplier);
          let destinationName = branch.name;
          return (
            destinationName.toLowerCase().includes(search) ||
            supplierName.toLowerCase().includes(search)
          );
        });
      } else {
        this.destinations = !search ? this.branchesOptions : [];
      }
    },
    selectDestination(destinatioId) {
      if (destinatioId) {
        this.query = this.addElementInQuery(
          this.query,
          "destination",
          destinatioId
        );
        this.get(true, this.limit, 1, this.query);
      } else {
        this.query = this.deleteItemInQuery(this.query, ["destination"]);
        this.get(true, this.limit, 1, this.query);
      }
    },
    getFormattedProductPrice(price) {
      if (price) {
        return parseFloat(price).toFixed(2);
      } else {
        return "0.00";
      }
    },
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setProductSearchCriteria",
      "setDuplicatedProduct",
      "setSettings"
    ]),
    ...mapActions(["getProducts", "getLimit"])
  },
  computed: {
    ...mapGetters([
      "products",
      "sesion",
      "userRole",
      "sigout",
      "paginationLimit",
      "productSearchCriteria",
      "settings",
      "branchesOptions"
    ]),
    canUserDelete() {
      return isUserAuthorized("EXPERIENCES", this.userRole, "DELETE");
    },
    canUserCreate() {
      return isUserAuthorized("EXPERIENCES", this.userRole, "CREATE");
    },
    canUserUpdate() {
      return isUserAuthorized("EXPERIENCES", this.userRole, "UPDATE");
    },
    canUserRead() {
      return isUserAuthorized("EXPERIENCES", this.userRole, "READ");
    },
    canUserCreateTag() {
      return isUserAuthorized("TAGS", this.userRole, "CREATE");
    },
    canUserExport() {
      return isUserAuthorized("EXPERIENCES", this.userRole, "EXPORT");
    },
    experiences: function() {
      try {
        let products = this.products.docs || [];
        return products.map(product => {
          return {
            productCode: product.code,
            title: product.name,
            destination: product.destination ? product.destination.city : "",
            category: product.service.category,
            vehicle: product.service.vehicle.name,
            seats: product.service.vehicle.seats,
            transferType: product.transfer.type,
            basePrice: product.pricing.amount,
            status: product.status,
            areaCode: product.area.name,
            availability: product.availability.type,
            pricingMethod: product.pricing_method,
            quote: product.quote,
            cutoff: product.cutoff.type,
            product: product
          };
        });
      } catch (error) {
        return [];
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInProductModule(to.meta.modules);
    next();
  }
};
</script>
